/* unplugin-vue-components disabled */import script from "./TotalOverdue.vue?vue&type=script&setup=true&lang=js"
export * from "./TotalOverdue.vue?vue&type=script&setup=true&lang=js"

import "./TotalOverdue.vue?vue&type=style&index=0&id=5587c096&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5587c096"]])

export default __exports__